import logo from '../../assets/images/logo.png';
import { Link } from 'react-router-dom';
import {useState} from "react";
import useConnectionStatus from '../utils/useConnectionStatus';
import { CONNECTION_STATUS } from '../utils/constants';

const Header = () => {
    const [login,setLogin] = useState("Login");
    const internetStatus = useConnectionStatus();
    return (
        <div className="shadow-lg h-16 flex justify-between px-36 items-center sticky top-0 z-50 bg-white">
            <div className="w-36">
                <img src={logo}/>
            </div>

            <div>
                <ul className='flex gap-12'>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about">About</Link></li>
                    <li><Link to="/contact">Contact Us</Link></li>
                    {/* <li>Internet : {internetStatus === CONNECTION_STATUS.ONLINE ? "online" : "offline"}</li> */}
                    <li>Cart</li>
                    <li><Link to='/grocery'>Grocery</Link></li>
                    <button className="btn_login_logout" onClick={
                        () => {
                            if(login === "Login") setLogin("Logout");
                            else setLogin("Login");
                        }
                    }>{login}</button>
                </ul>
            </div>

        </div>
    );
    
};

export default Header;